export default __webpack_public_path__ + "static/media/selimage-origin.988fb154.png";